import React from "react";
import { Download, Eye, Plus, Search } from "lucide-react";
import Pagination from "./Pagination";
import {
  fmtDate,
  getReadableOrderId,
  statusClass,
} from "../utils/inventory.helpers";

export default function OrdersSection({
  orderFilter,
  setOrderFilter,
  loadOrders,
  setOrderCreateOpen,
  loading,
  paginatedOrders,
  ordersPage,
  ordersTotalPages,
  setOrdersPage,
  onOpenOrderDetail,
  warehouseInventoryService,
}) {
  return (
    <>
      <div className="rounded-[20px] border border-[#f2c6cc] bg-white p-5">
        <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex gap-3">
            <select
              value={orderFilter}
              onChange={(e) => setOrderFilter(e.target.value)}
              className="h-[44px] rounded-[12px] border border-[#f2c6cc] px-4 text-[14px] outline-none focus:border-[#d86a78] focus:ring-2 focus:ring-[#f9dfe4]"
            >
              <option value="">All statuses</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="partially_approved">Partially Approved</option>
              <option value="rejected">Rejected</option>
            </select>

            <button
              type="button"
              onClick={loadOrders}
              className="inline-flex h-[44px] items-center justify-center gap-2 rounded-[12px] bg-[#d86a78] px-5 text-[14px] font-semibold text-white"
            >
              <Search size={16} />
              Apply
            </button>
          </div>

          <button
            type="button"
            onClick={() => setOrderCreateOpen(true)}
            className="inline-flex items-center gap-2 rounded-[12px] bg-[#d86a78] px-4 py-2.5 text-[13px] font-semibold text-white"
          >
            <Plus size={16} />
            New Order Request
          </button>
        </div>
      </div>

      <div className="rounded-[20px] border border-[#f2c6cc] bg-white shadow-[0_12px_30px_rgba(216,106,120,0.08)]">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#fff7f8]">
              <tr className="text-left text-[13px] font-semibold text-slate-600">
                <th className="px-5 py-4">Order ID</th>
                <th className="px-5 py-4">Status</th>
                {/* <th className="px-5 py-4">Items</th> */}
                <th className="px-5 py-4">Notes</th>
                <th className="px-5 py-4">Created</th>
                <th className="px-5 py-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    Loading order requests...
                  </td>
                </tr>
              ) : paginatedOrders.length ? (
                paginatedOrders.map((item) => (
                  <tr key={item.id} className="border-t border-[#f8dde1] text-[14px] text-slate-700">
                    <td className="px-5 py-4">
                      <div className="font-semibold text-slate-800">
                        {getReadableOrderId(item)}
                      </div>
                    </td>

                    <td className="px-5 py-4">
                      <span
                        className={[
                          "rounded-full border px-2.5 py-1 text-[11px] font-semibold",
                          statusClass(item.status),
                        ].join(" ")}
                      >
                        {item.status || "-"}
                      </span>
                    </td>

                    {/* <td className="px-5 py-4">
                      {Number(item.items_count || item.item_count || 0)}
                    </td> */}
                    <td className="px-5 py-4">{item.notes || "-"}</td>
                    <td className="px-5 py-4">{fmtDate(item.created_at)}</td>

                    <td className="px-5 py-4">
                      <div className="flex justify-end gap-2">
                        <button
                          type="button"
                          onClick={() => onOpenOrderDetail(item.id)}
                          className="inline-flex items-center gap-2 rounded-[10px] border border-[#f2c6cc] px-3 py-2 text-[12px] font-semibold text-slate-600"
                        >
                          <Eye size={14} />
                          View
                        </button>
                        <button
                          type="button"
                          onClick={() => warehouseInventoryService.exportOrder(item.id)}
                          className="inline-flex items-center gap-2 rounded-[10px] bg-[#d86a78] px-3 py-2 text-[12px] font-semibold text-white"
                        >
                          <Download size={14} />
                          Export
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="px-5 py-8 text-center text-[14px] text-slate-500">
                    No order requests found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={ordersPage}
          totalPages={ordersTotalPages}
          onChange={setOrdersPage}
        />
      </div>
    </>
  );
}